"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var DEFAULT_PATH = 'configurations/';
var DEFAULT_CONFIG = 'development';
var envsWithDynamicRegions = ['production', 'staging', 'edge'];
var ConfigLoader = (function () {
    function ConfigLoader() {
        var _this = this;
        this.setEnvironment = function (env) {
            _this.environment = env;
        };
        this.generateUrl = function () { return "https://consts.bringg.com/regions/".concat(_this.environment, ".json"); };
        this.environment = process.env.NODE_ENV;
    }
    ConfigLoader.prototype.fetchConfig = function (fullPath) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetch(fullPath)];
                    case 1:
                        response = _a.sent();
                        return [2, response.json()];
                }
            });
        });
    };
    ConfigLoader.prototype.loadInjectedFallbackRegions = function (path) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.fetchConfig("".concat(path).concat(this.environment, ".json"))];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    ConfigLoader.prototype.loadDynamicRegions = function (fallbackRegionsConfigPath) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 4]);
                        return [4, this.fetchConfig(this.generateUrl())];
                    case 1: return [2, _b.sent()];
                    case 2:
                        _a = _b.sent();
                        console.log("Failed to fetch regions for ".concat(this.environment, " env, loading from local (path: ").concat(fallbackRegionsConfigPath, ")."));
                        return [4, this.loadInjectedFallbackRegions(fallbackRegionsConfigPath)];
                    case 3: return [2, _b.sent()];
                    case 4: return [2];
                }
            });
        });
    };
    ConfigLoader.prototype.getRegionSpecificKeys = function (region, regionSpecificKeyNames) {
        var output = {};
        regionSpecificKeyNames === null || regionSpecificKeyNames === void 0 ? void 0 : regionSpecificKeyNames.forEach(function (key) {
            var value = region[key];
            if (value !== undefined) {
                output[key] = value;
            }
        });
        return output;
    };
    ConfigLoader.prototype.getCommonRegionKeys = function (defaultRegion, commonRegionKeyNames) {
        var output = {};
        commonRegionKeyNames === null || commonRegionKeyNames === void 0 ? void 0 : commonRegionKeyNames.forEach(function (key) {
            var value = defaultRegion[key];
            if (value !== undefined) {
                output[key] = value;
            }
        });
        return output;
    };
    ConfigLoader.prototype.mergeConfigWithRegions = function (_a) {
        var config = _a.config, regions = _a.regions, commonRegionKeyNames = _a.commonRegionKeyNames, regionSpecificKeyNames = _a.regionSpecificKeyNames;
        var newRegions = {};
        var commonRegionKeys = !!(commonRegionKeyNames === null || commonRegionKeyNames === void 0 ? void 0 : commonRegionKeyNames.length) &&
            this.getCommonRegionKeys(config.regions[config.default_region], commonRegionKeyNames);
        config.default_region = regions.default_region;
        for (var regionName in regions.regions) {
            var regionSpecificKeys = !!config.regions[regionName] &&
                !!(regionSpecificKeyNames === null || regionSpecificKeyNames === void 0 ? void 0 : regionSpecificKeyNames.length) &&
                this.getRegionSpecificKeys(config.regions[regionName], regionSpecificKeyNames);
            newRegions[regionName] = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, regions.regions[regionName]), commonRegionKeys), regionSpecificKeys);
        }
        config.regions = newRegions;
        return config;
    };
    ConfigLoader.prototype.load = function (path) {
        if (path === void 0) { path = DEFAULT_PATH; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 4]);
                        return [4, this.fetchConfig("".concat(path).concat(this.environment, ".json"))];
                    case 1:
                        config = _b.sent();
                        return [3, 4];
                    case 2:
                        _a = _b.sent();
                        return [4, this.fetchConfig("".concat(path).concat(DEFAULT_CONFIG, ".json"))];
                    case 3:
                        config = _b.sent();
                        return [3, 4];
                    case 4:
                        config.environment && this.setEnvironment(config.environment);
                        return [2, config];
                }
            });
        });
    };
    ConfigLoader.prototype.loadWithInjectedFallbackRegions = function (_a) {
        var fallbackRegionsConfigPath = _a.fallbackRegionsConfigPath, commonRegionKeyNames = _a.commonRegionKeyNames, regionSpecificKeyNames = _a.regionSpecificKeyNames, _b = _a.localConfigPath, localConfigPath = _b === void 0 ? DEFAULT_PATH : _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, regions;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4, this.load(localConfigPath)];
                    case 1:
                        config = _c.sent();
                        if (!(envsWithDynamicRegions.includes(this.environment) && config)) return [3, 3];
                        return [4, this.loadInjectedFallbackRegions(fallbackRegionsConfigPath)];
                    case 2:
                        regions = _c.sent();
                        config = this.mergeConfigWithRegions({
                            config: tslib_1.__assign({}, config),
                            regions: regions,
                            commonRegionKeyNames: commonRegionKeyNames,
                            regionSpecificKeyNames: regionSpecificKeyNames
                        });
                        _c.label = 3;
                    case 3: return [2, config];
                }
            });
        });
    };
    ConfigLoader.prototype.loadWithFetchedRegions = function (_a) {
        var fallbackRegionsConfigPath = _a.fallbackRegionsConfigPath, commonRegionKeyNames = _a.commonRegionKeyNames, regionSpecificKeyNames = _a.regionSpecificKeyNames, _b = _a.localConfigPath, localConfigPath = _b === void 0 ? DEFAULT_PATH : _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, regions;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4, this.load(localConfigPath)];
                    case 1:
                        config = _c.sent();
                        if (!(envsWithDynamicRegions.includes(this.environment) && config)) return [3, 3];
                        return [4, this.loadDynamicRegions(fallbackRegionsConfigPath)];
                    case 2:
                        regions = _c.sent();
                        config = this.mergeConfigWithRegions({
                            config: tslib_1.__assign({}, config),
                            regions: regions,
                            commonRegionKeyNames: commonRegionKeyNames,
                            regionSpecificKeyNames: regionSpecificKeyNames
                        });
                        _c.label = 3;
                    case 3: return [2, config];
                }
            });
        });
    };
    ConfigLoader.prototype.getRegionsKeys = function (config, commonRegionKeyNames, regionSpecificKeyNames) {
        var commonRegionKeys = this.getCommonRegionKeys(config.regions[config.default_region], commonRegionKeyNames);
        var regionSpecificKeys = {};
        for (var regionName in config.regions)
            regionSpecificKeys[regionName] = this.getRegionSpecificKeys(config.regions[regionName], regionSpecificKeyNames);
        return {
            commonRegionKeys: commonRegionKeys,
            regionSpecificKeys: regionSpecificKeys
        };
    };
    return ConfigLoader;
}());
exports.default = ConfigLoader;
//# sourceMappingURL=config-loader.js.map